import { h, ComponentChildren } from 'preact';
import type { Preview } from '../../types';
import { VertexLink } from './VertexLink';

export interface VertexSquareCardProps {
  url: string;
  preview?: Preview;
  onClick?: () => void;
  actions?: h.JSX.Element;
  extraContent?: ComponentChildren;
  fromUnion?: boolean;
}

export function VertexSquareCard({ url, preview, onClick, actions, extraContent, fromUnion }: VertexSquareCardProps) {
  const className = fromUnion ? 'graph-edge-card graph-edge-card-union' : 'graph-edge-card';
  return (
    <div
      class={className}
      onClick={onClick}
      title={url}
      style={onClick ? undefined : { cursor: 'default' }}
    >
      {preview?.image && (
        <img
          src={preview.image}
          alt=""
          class="graph-edge-card-image"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      )}

      <div class="graph-edge-card-content">
        <div class="graph-edge-card-title">
          {preview?.title || url}
        </div>
        {preview?.description && (
          <div class="graph-edge-card-desc">{preview.description}</div>
        )}
        <VertexLink href={url} class="graph-edge-card-url">
          {url}
        </VertexLink>
        {extraContent}
      </div>

      {actions && (
        <div class="graph-edge-card-actions">
          {actions}
        </div>
      )}
    </div>
  );
}
